const state = {
  forumInfo: {},
};

const mutations = {
  SET_FORUM_INFO(currentState, info = {}) {
    currentState.forumInfo = info;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
